
export interface Product {
  AdvancedType: AdvancedTypes;
  Cost: number;
  CustomTextLimit: number;
  Description: string;
  Id: number;
  ImageUrl: string;
  InBag: InBagItem[];
  IsHidden: boolean;
  Name: string;
  Sizes: string[];
  Limit:number;
  Removable:boolean;
  GroupWith?:number;
  GroupParentItem?:string;
}

interface InBagItem {
  Count: number;
  Size: string;
  Custom: string;
  Free:boolean;
}

export enum AdvancedTypes {
  Normal = '1000',
  TeacherRegistrationFee = '3000',
  HousingPackage = '7000',
  AdditionalAttendee = '7500',
  HandlingLabel = '8000',
  SponsorshipTier = '14000',
}

export interface ProductsResponse {
  payContinueBtnText: string;
  continueBtnText: string;
  headerText:string;
  footerText:string;
  cartCount: number;
  coupons: string[];
  msg: string | null;
  products: Product[];
  savings: number;
  ///In dollars
  total: number;
  ///In dollars  
  cardFee: number;
  NewRecord: boolean;
  AccountAlreadyCreated?: boolean;
  NextRecordPath: string;
  registrationFeeOptions:IRegistrationFeeInfo;
  AltCheckoutPaymentMethod:IAltCheckoutPaymentMethod;
  generateInvoiceTabLabel:string;
  generateInvoiceHeader:string;
}

export interface IAltCheckoutPaymentMethod{
  IsEnabled:boolean;
  Name:string;
  DescriptionHtml:string;
  NotifyEmailCsv:string;
  ShowInRegistrationFlow:string;
  GenerateInvoice:boolean;
  AutoAddCouponsToInvoice:boolean;
  ItemsToWhichCouponsMayBeApplied:number[];
  CouponPrefix:string;
  LabelTab:string;
  LabelNotes:string;
  LabelApplyToList:string;
  LabelContinueBtn:string;
};

export interface IRegistrationFeeInfo{
    checkInstructions:string;
    hasRegistrationFee:boolean;
    payByCheck:boolean;
    payByFeeWavier:boolean;
    payBySchool:boolean;
    generateInvoice:boolean;
}

export interface InvoicePaymentRequestResponse {
  OrderId:string;
  ConfirmationCode:string;
  Pass:boolean;
  Message:string;
  RegisterPass:string;
  NextRecordPath:string;
  UserId:string;
  ProjectKey:string;
  ProjectId:string;
}

export interface FullShoppingCartItem extends InBagItem {
  Cost: number;
  Name: string;
  Id: number;
  Limit: number;
  Removeable:boolean;
}

export interface InvoicePaymentRequest{
    FirstName: string;   
    LastName: string;   
    Email: string;   
    Phone: string;   
    Last4: string;   
    Year: string;   
    Month: string;   
    Zip: string;   
    OrderId: string;
    Token: string; 
}  